export default "__VITE_ASSET__201e3b3b__"